<template>
  <div
    :class="(canClick ? '' : '-pe-n') + ' swp-kw b -o-y-a w-f'"
    style="scrollbar-width: thin;scrollbar-color: rgb(255, 225, 137) transparent;"
    @mousedown="downEvent"
    @dragstart.prevent=""
    @click.prevent=""
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SwpKWidget',
  props: {},
  data () {
    return {
      target: undefined,
      isDown: false,
      isMove: false,
      canClick: true,
      x_0: 0,
      y_0: 0,
      x: 0,
      y: 0
    }
  },
  methods: {
    downEvent (e) {
      this.x_0 = e.clientX
      this.y_0 = e.clientY
      this.isDown = true
      this.target = e.target.closest('.swp-kw')
    },
    moveEvent (e) {
      if (this.isDown) {
        this.target.scrollLeft = this.target.scrollLeft - e.movementX
        this.target.scrolltop = this.target.scrolltop - e.movementY
        this.isMove = true
        this.canClick = false
      }
    },
    upEvent () {
      this.isDown = false
      setTimeout(() => {
        this.canClick = true
      }, 100)
    },
    leaveEvent () {
      this.isMove = false
      setTimeout(() => {
        this.canClick = true
      }, 100)
    },
    clickEvent (e) {
      if (!this.canClick) {
        e.stopPropagation()
      }
    }
  },
  created () {
    document.body.addEventListener('mousemove', this.moveEvent)
    document.body.addEventListener('mouseup', this.upEvent)
    document.body.addEventListener('mouseleave', this.leaveEvent)
    document.body.addEventListener('click', this.clickEvent)
  }
}
</script>
